import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { AppService } from './services/app.service';
import { ThemeService } from './services/theme/theme.service';
import { AuthProvider } from './enums/auth-provider';
import { UtilityFunctions } from './utilities/utility-functions';
import { MessageSeverity } from './enums/message-severity';
import { UserSession } from './interfaces/user-session';
import { ScreenSize } from './enums/screen-size';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent {

    public title: string = 'lutzangeles.ui';
    public subdomain: string = "";
    public dims: string = "(dims)";
    public isDiagnosticsOn: boolean = false;

    public constructor(public appService: AppService, private themeService: ThemeService, private elRef: ElementRef, private router: Router) {

        this.detectScreenSize(window.innerWidth);
    }

    public ngOnInit() {

        this.themeService.loadTheme("light");
    }

    public ngAfterViewInit(): void {

        this.tryLogin();
    }

    @HostListener('window:resize', ['$event'])
    public onResize(event: any) {

        this.detectScreenSize(event.target.innerWidth);

        this.updateDims();
    }

    private tryLogin = (): void => {

        this.subdomain = UtilityFunctions.getSubdomain();

        var userSessionString: string = UtilityFunctions.getUserSession();

        if (userSessionString && userSessionString != "") {

            const userSession: UserSession = JSON.parse(userSessionString);

            this.appService.loggedInApp(userSession);

            let destination: string = "";
            const currentRoute: string = this.router.url.split('?')[0];

            if (currentRoute === "/at/night") {

                destination = "/at/night";
            }

            //this.appService.navigateTo(destination, "");

        } else {

            // 
        }
    }

    public detectScreenSize = (width: number): void => {

        let screenSize: ScreenSize;

        if (width < 768) {

            screenSize = ScreenSize.Mobile;

        } else if (width < 1440) {

            screenSize = ScreenSize.Tablet;

        } else {

            screenSize = ScreenSize.Desktop;
        }

        if (screenSize !== this.appService.screenSize) {

            this.appService.screenSize = screenSize;

            this.appService.screenSizeChange.emit(this.appService.screenSize);
        }
    }

    public onRouteActivated(componentInstance: any): void {

        if (componentInstance.componentReady instanceof EventEmitter) {

            componentInstance.componentReady.subscribe((componentName: string) => {

                this.updateDims();
            });
        }
    }

    private updateDims(): void {

        const container = this.elRef.nativeElement.querySelector('.rolling-zoom') as HTMLElement;
        const image = container?.querySelector('img') as HTMLImageElement;

        if (container && image) {

            const cW = container.offsetWidth;
            const cH = container.offsetHeight;
            const iW = image.offsetWidth;
            const iH = image.offsetHeight;

            const containerRatio = (cW / cH).toFixed(3);
            const imageRatio = (iW / iH).toFixed(3);

            this.dims = `🟪: ${cW}×${cH} (AR: ${containerRatio}) - 🖼️: ${iW}×${iH} (AR: ${imageRatio})`;

        } else {

            this.dims = "dims";
        }
    }
}
